import React, { useEffect, useState } from "react";
import moment from "moment";
import classnames from "classnames";

import Table from "../../ui/Table/Table";
import { CommonPayoutsService } from "../../utils/api";
import useSort from "../../hooks/useSort";
import spaceint2 from "../../utils/spaceint2";
import DateRange from "../../ui/DateRange/DateRange";
import formatDate from "../../utils/formatDate";

const renderMoney = ({ data, columnInfo }) => (
  <span>{spaceint2(data[columnInfo.accessor])} ₽</span>
);
const renderSummaryMoney = ({ summaryInfo, summary }) => (
  <span>{spaceint2(summary[summaryInfo.accessor])} ₽</span>
);

const renderSuccessCount = ({ data, columnInfo }) => (
  <span>
    {data[columnInfo.accessor]} ({spaceint2(data.success_percent)}%)
  </span>
);

const columns = [
  {
    title: "Дата",
    accessor: "date",
    renderDataCell: ({ data }) => {
      return formatDate(data.date);
    }
  },
  {
    title: "Добавлено",
    accessor: "add_count"
  },
  {
    title: "Успешные",
    accessor: "success_count",
    renderDataCell: renderSuccessCount
  },
  {
    title: "Неуспешные",
    accessor: "fail_count"
  },
  {
    title: "Оштрафовано",
    accessor: "penalty_count",
    className: "table__border-right",
    dataClassName: "table__border-right"
  }
];

const summaryColumns = [
  {
    title: "Итого",
    colSpan: 5,
    className: "table__border-right",
    align: "left"
  }
];

const TeaserPayTable = ({ search, setDateRange }) => {
  const [state, setState] = useState({ stat: [], summary: {} });
  const [loading, setLoading] = useState(true);
  const { sortBy, sortOrder, onSortChange } = useSort("date", "asc");

  useEffect(() => {
    setLoading(true);

    CommonPayoutsService(search)
      .then(data => {
        setState(data);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  return (
    <React.Fragment>
      <div className="page-pay__date-range">
        <DateRange
          className="left"
          startDate={moment(search.date_from)}
          endDate={moment(search.date_to)}
          onChange={setDateRange}
        />
      </div>
      <Table
        columns={columns}
        data={state.stat}
        summary={state.summary}
        summaryColumns={summaryColumns}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
        className="buy"
        loading={loading}
      />
    </React.Fragment>
  );
};

export default TeaserPayTable;
